import { rangeArrayUtil } from 'packages/src'

export const SET_DATA_KEY = {
  REPS: 'reps',
  TIME: 'time',
  REST: 'rest',
  RATE_OF_PERCEIVED_EXERTION: 'rateOfPerceivedExertion',
  ESTIMATED_RATE_OF_PERCEIVED_EXERTION: 'estimatedRateOfPerceivedExertion',
  WEIGHT: 'weight',
  WEIGHT_UNIT: 'weightUnit',
  NOTES: 'notes',
  TIME_ELAPSED: 'timeElapsed',
  WEIGHT_EQUIPMENT: 'weightEquipment',
  ENTER_TIME_MANUALLY: 'enterTimeManually',
  HAS_REFUSED_SUGGESTED_SET: 'hasRefusedSuggestedSet',
  HAS_ACCEPTED_SUGGESTED_SET: 'hasAcceptedSuggestedSet'
}

export const SET_DATA_KEYS_TO_CHECK_FOR_EQUALITY = [
  SET_DATA_KEY.REPS,
  SET_DATA_KEY.TIME,
  SET_DATA_KEY.REST,
  SET_DATA_KEY.WEIGHT,
  SET_DATA_KEY.WEIGHT_UNIT
]
export const SET_DATA_KEYS_TO_OMIT_WHEN_COPYING = [
  SET_DATA_KEY.TIME_ELAPSED,
  SET_DATA_KEY.HAS_REFUSED_SUGGESTED_SET,
  SET_DATA_KEY.HAS_ACCEPTED_SUGGESTED_SET,
  SET_DATA_KEY.RATE_OF_PERCEIVED_EXERTION
]

export const SET_DATA_COUNT_UNIT_KEYS = [
  SET_DATA_KEY.REPS,
  SET_DATA_KEY.TIME,
  SET_DATA_KEY.REST
]

export const SET_DATA_WEIGHT_KEY_BODY_WEIGHT = 'Bodyweight'

export const SET_TIME_AVAILABLE = [
  1,
  2,
  3,
  4,
  5,
  6,
  8,
  10,
  15,
  20,
  25,
  30,
  35,
  40,
  45,
  50,
  55,
  60,
  65,
  70,
  75,
  80,
  85,
  90,
  120,
  180,
  240,
  300,
  600,
  900,
  1200,
  1500,
  1800,
  2100,
  2400,
  2700,
  3000,
  3300,
  3600,
  3900,
  4200,
  4500,
  4800,
  5100,
  5400,
  5700,
  6000,
  6300,
  6600,
  6900,
  7200,
  7500,
  7800,
  8100,
  8400,
  8700,
  9000,
  9300,
  9600,
  9900,
  10200,
  10500,
  10800,
  11100,
  11400,
  11700,
  12000,
  12300,
  12600,
  12900,
  13200,
  13500,
  13800,
  14100,
  14400,
  14700,
  15000,
  15300,
  15600,
  15900,
  16200,
  16500,
  16800,
  17100,
  17400,
  17700,
  18000
]

export const COUNT_KEY_TO_VALUES = {
  [SET_DATA_KEY.REPS]: rangeArrayUtil(1, 101),
  [SET_DATA_KEY.TIME]: SET_TIME_AVAILABLE,
  [SET_DATA_KEY.REST]: SET_TIME_AVAILABLE
}
